/**
 * Default Popup Settings Configuration
 * Provides default values for event popup behavior
 */
import { EventPopupSettings } from '../../app/contracts/YearlyCalendarContracts';

/**
 * Default popup settings
 */
export const DEFAULT_POPUP_SETTINGS: EventPopupSettings = {
  // Display settings
  showAddEvent: true,
  showEventCount: true,
  showEventDetails: true,
  showEventTime: true,
  showEventType: true,
  
  // Behavior settings
  closeOnEscape: true,
  closeOnOutsideClick: true,
  trapFocus: true,
  autoPosition: true,
  
  // Labels
  addEventLabel: 'Add Event',
  noEventsLabel: 'No events scheduled',
  moreEventsLabel: '{count} more',
  
  // Customization hooks (set via props)
  customPopupHeader: undefined,
  customEventRenderer: undefined,
  customAddEventButton: undefined,
};

/**
 * Create merged popup settings with defaults
 */
export const createPopupSettings = (
  partialSettings?: Partial<EventPopupSettings>
): EventPopupSettings => {
  if (!partialSettings) {
    return { ...DEFAULT_POPUP_SETTINGS };
  }
  
  return {
    ...DEFAULT_POPUP_SETTINGS,
    ...partialSettings,
  };
};

/**
 * Minimal popup settings (for compact views)
 */
export const MINIMAL_POPUP_SETTINGS: Partial<EventPopupSettings> = {
  showEventDetails: false,
  showEventTime: false,
  showEventType: false,
  showEventCount: true,
};

/**
 * Full detail popup settings
 */
export const FULL_POPUP_SETTINGS: Partial<EventPopupSettings> = {
  showAddEvent: true,
  showEventCount: true,
  showEventDetails: true,
  showEventTime: true,
  showEventType: true,
};

/**
 * Read-only popup settings (no add event)
 */
export const READONLY_POPUP_SETTINGS: Partial<EventPopupSettings> = {
  showAddEvent: false,
  showEventCount: true,
  showEventDetails: true,
};

export default DEFAULT_POPUP_SETTINGS;
